import React from 'react';
import AracHasarHesap from '../components/AracHasar/AracHasarHesap';
import './IscilikAlacaklariHesap.css';

/*
  Hesaplama menüsü > Hasar ve Değer Kaybı.
  Hesap bileşeni dosya formunda da açılabiliyor (components/AracHasar).
*/
const AracHasarHesapSayfasi = () => (
  <div className="ia-page">
    <div className="page-header ia-header">
      <div>
        <h1>Araç Hasar ve Değer Kaybı Hesabı</h1>
        <p className="ia-header-sub">
          Maddi hasar, değer kaybı (ikinci el piyasa farkı), araç mahrumiyeti · Genel Şartlar 01.07.2026 ve Yargıtay esasları
        </p>
      </div>
    </div>
    <AracHasarHesap />
  </div>
);

export default AracHasarHesapSayfasi;
